<script>
    import { fly } from "svelte/transition";
    export let image;
    export let isOpen;

</script>

{#if isOpen}
    <div class="flex w-9/12 md:w-6/12 items-center justify-center image-modal p-2" transition:fly|global>
        <img src="{image.link}" class="object-fill" alt="{image.originalName}" />
    </div>
{/if}

<style>
    .image-modal {
        aspect-ratio: 16/9;
        background-color: white;
        border-radius: 5px;
        padding: 15px;
        position: fixed;
        z-index: 85;
        left: 50%;
        translate: -50%;
        top: 3rem;
        margin: auto;
    }
</style>